import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import classNames from 'classnames/bind';
import styles from '../loginForm.less';


const cx = classNames.bind(styles);

const COUNT_DOWN_START_TIME_SECONDS = 60;

const CountDownTimer = ({ timerStatusChangeHandler, intl }) => {
  const [seconds, setSeconds] = useState(0);
  const [timerActivated, setTimerActivated] = useState(false);
  const [buttonStatus, setButtonStatus] = useState({ touched: false, disabled: false });

  useEffect(() => {
    let isMounted = true;
    if (seconds === 0) {
      setButtonStatus({ touched: true, disabled: false });
      setTimerActivated(false);
    } else if (timerActivated) {
      setTimeout(() => {
        if (isMounted) {
          setSeconds(prevState => prevState - 1);
        }
      }, 1000);
    }
    return () => { isMounted = false; };
  }, [timerActivated, seconds, timerStatusChangeHandler]);

  useEffect(() => {
    setButtonStatus({ touched: false, disabled: false });
  }, []);

  const handleClick = e => {
    e.preventDefault();
    timerStatusChangeHandler(true);
    setTimerActivated(true);
    setButtonStatus({ touched: true, disabled: true });
    setSeconds(COUNT_DOWN_START_TIME_SECONDS);
  };

  const { formatMessage } = intl;
  const { touched, disabled } = buttonStatus;
  const btnLabel = touched ? formatMessage({ id: 'global.info.resendCode' }) : formatMessage({ id: 'global.info.getCode' });
  const msg = seconds > 0 ? `${seconds.toString().padStart(2, '0')}s` : '';
  return (
    <Button className={cx('getCodeBtn')} disabled={disabled} onClick={handleClick}>
      {`${btnLabel} ${msg}`}
    </Button>
  );
};

export default CountDownTimer;



// WEBPACK FOOTER //
// ./src/views/LoginForm/components/CountDownTimer.jsx